import React, { memo } from "react"
import FormInputWrapper from "./FormInputWrapper"
import TextInput from "../inputs/TextInput"

const TextInputWrapper = props => {
  return <FormInputWrapper {...props} component={TextInput} />
}

export default memo(TextInputWrapper)
